import { useEffect, useMemo, useState } from "react";

import _ from "lodash";

import { theme } from "app/App";
import useNotification from "notification";

import { Box, Button, CircularProgress, Typography } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/Delete";

import WindowDialog from "components/dialog/WindowDialog";
import FForm, { useFormApi } from "components/form";
import { NestedField, useFieldValue } from "components/form/input/NestedField";
import SubmitButton from "components/form/SubmitButton";
import FormContent from "components/form/FormContent";
import ConfirmDialog from "components/dialog/ConfirmDialog";
import { showDialog } from "components/dialog";

const ApontamentoFormEditor = ({ IndicadorClass, visita, isNew, TipoClass }) => {
    const [type, setType] = useFieldValue("tipo") // pego se é mecanizado ou manual, conforme formulário do indicador sendo preenchid
    const [paramsCliente, setParamsCliente] = useFieldValue("paramsCliente");

    if (type) {
        const params = visita.cliente.getParams(IndicadorClass, type, TipoClass);

        if (!_.isEqual(paramsCliente, params)) {
            setParamsCliente(params);
        }
    }

    return <FormContent sx={{ mt: 1, mb: 2 }}>{IndicadorClass.getEditFields(visita, isNew, TipoClass)}</FormContent>;
};
export default function ApontamentoDialog({
    visita,
    TipoClass,
    IndicadorClass,
    apontamentoIndex,
    setDialog,
    talhao,
    ...props
}) {
    const { showSuccess } = useNotification();

    const form = useFormApi();
    const [dialog, _setDialog] = useState();
    const [deleteDialog, setDeleteDialog] = useState();
    const [formValues, setFormValues] = useState();
    const [_apontamentoIndex, setApontamentoIndex] = useState();

    const isNew = _.isNil(apontamentoIndex);

    const indicador = useMemo(
        () => (IndicadorClass && TipoClass ? new IndicadorClass(TipoClass) : null),
        [IndicadorClass, TipoClass]
    );

    useEffect(() => {
        // Precisamos do estado do diálogo internamente, mas também exportar pelo prop quando necessário.
        if (setDialog) {
            setDialog(dialog);
        }
    }, [dialog, setDialog]);

    useEffect(() => {
        async function updateForm() {
            // Novo.
            if (indicador && isNew) {
                // Adiciona um novo apontamento em uma cópia da visita, que pode ser salva ou descartada.
                const visitaClone = _.cloneDeep(visita);

                const index = await indicador.createApontamento(visitaClone, talhao);

                setFormValues(visitaClone.data);
                setApontamentoIndex(index);
            } else {
                setFormValues(visita.data);
                setApontamentoIndex(apontamentoIndex);
            }
        }

        updateForm();

        // É importante que visita.data esteja nas dependências para atualizar formulário ao salvar.
    }, [apontamentoIndex, indicador, isNew, talhao, visita, visita.data]);

    async function handleSubmit(values) {
        visita.update(values);

        visita.save().then((success) => {
            showSuccess("Apontamento salvo com sucesso.");
            visita.update(values);
        });

        dialog.setOpen(false);
    }

    function remove() {
        showDialog(deleteDialog).then((confirm) => {
            if (confirm) {
                indicador.removeApontamento(visita, _apontamentoIndex);

                dialog.setOpen(false);
            }
        });
    }

    if (!indicador) {
        return (
            <WindowDialog setDialog={_setDialog} {...props}>
                {(dialogProps) => <Typography>Nenhum apontamento para editar.</Typography>}
            </WindowDialog>
        );
    }

    return (
        <>
            <WindowDialog
                title={IndicadorClass.abbrev}
                maxWidth="xl"
                contentProps={{ sx: { p: 1 } }}
                titleProps={{ sx: { p: 2 } }}
                titleButtons={
                    <Box sx={{ display: "flex", gap: 1 }}>
                        <SubmitButton size="small" startIcon={<CheckIcon />} onClick={() => form.submit()} />
                        <Button size="small" startIcon={<CloseIcon />} onClick={() => dialog.setOpen(false)}>
                            Cancelar
                        </Button>
                    </Box>
                }
                hideCloseButton
                setDialog={_setDialog}
                {...props}
            >
                {(dialogProps) => (
                    <FForm
                        onSubmit={handleSubmit}
                        initialValues={formValues}
                        formApi={form}
                        contentProps={{ sx: { gap: 0 } }}
                    >
                        {_apontamentoIndex !== undefined ? (
                            <NestedField prefix={indicador.apontamentosField} index={_apontamentoIndex}>
                                <Box
                                    sx={{
                                        display: "flex",
                                        flexBasis: "100%",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        p: 1,
                                    }}
                                >
                                    <Typography color={theme.palette.grey[600]} fontWeight="bold">
                                        {IndicadorClass.fullName}
                                    </Typography>

                                    {isNew ? null : (
                                        <Button title="Excluir Apontamento" onClick={remove}>
                                            <DeleteIcon />
                                        </Button>
                                    )}
                                </Box>
                                <ApontamentoFormEditor
                                    IndicadorClass={IndicadorClass}
                                    visita={visita}
                                    isNew={isNew}
                                    TipoClass={TipoClass}
                                />
                            </NestedField>
                        ) : (
                            <CircularProgress />
                        )}
                    </FForm>
                )}
            </WindowDialog>

            <ConfirmDialog title="Remover" requiredInput="excluir" setDialog={setDeleteDialog}>
                Deseja realmente remover este apontamento?
            </ConfirmDialog>
        </>
    );
}
